import React from "react";
import { motion } from "framer-motion";
import ScriptureCard from "@/components/ScriptureCard";
import BreathingExercise from "@/components/BreathingExercise";
import { CRISIS_RESOURCES, GROUNDING_STEPS } from "@/data/content";
import { Phone, LifeBuoy, TriangleAlert, HandHeart } from "lucide-react";

export default function CrisisPage() {
  return (
    <div className="space-y-8" data-testid="crisis-page">
      <div>
        <p className="uppercase tracking-[0.2em] text-xs text-terracotta mb-2">You are not alone</p>
        <h1 className="font-serif text-display text-olive">Support &amp; safety</h1>
      </div>

      <div className="flex gap-3 rounded-3xl bg-terracotta/10 text-terracotta p-6" data-testid="emergency-warning">
        <TriangleAlert className="w-6 h-6 shrink-0" />
        <div>
          <p className="font-medium">If this is an emergency, call 911 now.</p>
          <p className="text-sm mt-1 text-terracotta/90">
            Seek immediate help for chest pain, trouble breathing, severe confusion, or thoughts of self-harm. You never have to face a hard moment alone.
          </p>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="space-y-4">
          <h2 className="font-serif text-2xl text-olive flex items-center gap-2"><LifeBuoy className="w-5 h-5 text-sky" /> Helplines</h2>
          {CRISIS_RESOURCES.map((r) => (
            <a key={r.name} href={`tel:${r.tel}`} data-testid={`crisis-page-resource-${r.tel}`}
              className="flex items-center gap-4 rounded-3xl bg-card border border-border p-5 shadow-soft transition-colors hover:bg-sage">
              <div className="rounded-full bg-terracotta/10 p-3"><Phone className="w-5 h-5 text-terracotta" /></div>
              <div>
                <p className="font-medium text-olive">{r.name}</p>
                <p className="text-sm text-stone">{r.detail}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="space-y-6">
          <ScriptureCard compact />
          <div className="rounded-3xl bg-card border border-border p-6 shadow-soft" data-testid="grounding-card">
            <h2 className="font-serif text-2xl text-olive flex items-center gap-2 mb-4"><HandHeart className="w-5 h-5 text-sky" /> Grounding: 5-4-3-2-1</h2>
            <ol className="space-y-2 text-olive/80 list-decimal list-inside">
              {GROUNDING_STEPS.map((s, i) => <li key={i}>{s}</li>)}
            </ol>
          </div>
        </div>
      </div>

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="rounded-3xl bg-sky/10 border border-border p-4">
        <h2 className="font-serif text-2xl text-olive text-center mt-3">Breathe with me for a moment</h2>
        <BreathingExercise />
      </motion.div>
    </div>
  );
}
